import React from 'react';
import { VenueProfileContext } from '../../context';
import { Venues } from '@weddingspot/ws-api-client';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import { GMAPS_API_KEY } from '../../../../configs/appconfig';

const VenueLocation = () => {
    const context = React.useContext(VenueProfileContext);

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, []) as Venues.VenueDetails;

    if (!wsVenueProfile || !wsVenueProfile.latitude || !wsVenueProfile.longitude) {
        return null;
    }

    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key: GMAPS_API_KEY }}
            defaultCenter={{
                lat: wsVenueProfile.latitude,
                lng: wsVenueProfile.longitude,
            }}
            defaultZoom={12}
        >
            <Marker
                lat={wsVenueProfile.latitude}
                lng={wsVenueProfile.longitude}
                address={wsVenueProfile.address_1}
                state={wsVenueProfile.state}
                name={wsVenueProfile.name}
                onClick={() => {
                    window.open(`https://maps.google.com/?q=${wsVenueProfile.latitude},${wsVenueProfile.longitude}`, '_blank');
                }}
            />
        </GoogleMapReact>
    );
};

export default VenueLocation;
